import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './directive';
import { getDeductSort as _getDeductSort, saveDeductSort } from 'api/payroll/salary-scheme/detail';
export default {
  props: {
    activeObj: {
      type: Object
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isDisplay: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    }
  },
  data: function data() {
    return {
      activeNames: this.isShow ? [0, 1] : [],
      activeInfo: this.activeObj ? this.activeObj.data.info : {
        list: []
      },
      cActiveInfo: this.activeObj ? this.activeObj.data.cInfo : {
        list: []
      } // 拷贝数据，判断是否修改
    };
  },
  mounted: function mounted() {
    this.getDeductSort();
  },
  methods: {
    getDeductSort: function getDeductSort() {
      var _this = this;
      _getDeductSort({
        payroll_sub_project_scheme_id: this.id || this.$route.params.id
      }).then(function (_ref) {
        var data = _ref.data;
        _this.activeInfo = Object.assign(_this.activeInfo, {
          list: data
        });
        _this.cActiveInfo = JSON.parse(JSON.stringify(_this.activeInfo));
      });
    },
    // 上移 下移
    handleData: function handleData(row, index, type) {
      this.activeInfo.list.splice(index, 1);
      if (type === 'down') this.activeInfo.list.splice(index + 1, 0, row);else this.activeInfo.list.splice(index - 1, 0, row);
      this.activeInfo.list.forEach(function (item, index) {
        item.sort = index + 1;
      });
    },
    saveData: function saveData() {
      return saveDeductSort({
        payroll_sub_project_scheme_id: this.id || this.$route.params.id,
        deduct: this.activeInfo.list
      });
    }
  }
};